var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{on:{"click-left":_vm.$navigateBack},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"size":"24","name":"arrow-left"}})]},proxy:true}])}),_c('div',{staticClass:"iframe"},[_c('iframe',{attrs:{"src":_vm.url}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }